module.exports = __webpack_public_path__ + "static/img/logo.3ef2b697.png";